import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { movieService } from '../services/movie-service.js'
import MovieFilter from '../views/MovieFilter.jsx'
import Hero from '../views/Hero.jsx'
import MovieCard from '../views/MovieCard.jsx'
import MovieRow from '../views/MovieRow.jsx'
import { SkeletonGrid } from '../views/Skeleton.jsx'

const Movies = () => {
  const [filterBy, setFilterBy] = useState({
    movieTitle: '',
    rating: '',
    year: '',
  })

  const navigate = useNavigate()
  const [displayCount, setDisplayCount] = useState(18)
  const [movies, setMovies] = useState()
  const [filteredMovies, setFilteredMovies] = useState()

  const [rows, setRows] = useState({ trending: [], top_rated: [], now_playing: [] })
  const [rowsLoading, setRowsLoading] = useState(true)

  useEffect(() => {
    loadMovies()
    loadRows()
  }, [])

  useEffect(() => {
    if (movies) {
      setFilteredMovies(movies.filter(filterMovie))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [movies, filterBy])

  async function loadMovies() {
    const movieList = await movieService.getMovies()
    setMovies(movieList)
  }

  async function loadRows() {
    setRowsLoading(true)
    const [trending, topRated, nowPlaying] = await Promise.all([
      movieService.getTrending(),
      movieService.getByCategory('top_rated'),
      movieService.getByCategory('now_playing'),
    ])
    setRows({ trending, top_rated: topRated, now_playing: nowPlaying })
    setRowsLoading(false)
  }

  const handleReadMore = (media) => {
    navigate(`/show/${media.id}`, {
      state: { media, fromSearch: false },
    })
  }

  const handleLoadMore = () => setDisplayCount(displayCount + 18)
  const handleSetFilter = (newFilterBy) => setFilterBy(newFilterBy)

  const filterMovie = (movie) => {
    const { movieTitle, rating, year } = filterBy
    if (
      movieTitle &&
      !movie.title.toLowerCase().includes(movieTitle.toLowerCase())
    ) {
      return false
    }
    if (rating && movie.vote_average < rating) return false
    if (year) {
      const date = movie.release_date || movie.first_air_date
      if (!date || date.substring(0, 4) !== year) return false
    }
    return true
  }

  return (
    <>
      <Hero />

      <MovieRow
        title='Trending This Week'
        eyebrow='Hot right now'
        items={rows.trending}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />
      <MovieRow
        title='Top Rated'
        eyebrow='Critically acclaimed'
        items={rows.top_rated}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />
      <MovieRow
        title='Now Playing'
        eyebrow='In theaters'
        items={rows.now_playing}
        loading={rowsLoading}
        onReadMore={handleReadMore}
      />

      <section id='movies'>
        <div className='container movies-container'>
          <div className='section-head'>
            <span className='eyebrow'>Browse the library</span>
            <h1>All Movies</h1>
            <p className='sub'>
              {filteredMovies ? `${filteredMovies.length} titles` : 'Loading'} —
              search, filter by year and rating.
            </p>
          </div>

          <MovieFilter onSetFilter={handleSetFilter} />

          {filteredMovies ? (
            <>
              <div className='movie-grid grid'>
                {filteredMovies.slice(0, displayCount).map((movie) => (
                  <MovieCard
                    key={movie.id}
                    media={movie}
                    onReadMore={handleReadMore}
                  />
                ))}
              </div>

              {filteredMovies.length === 0 && (
                <p className='empty-state'>No titles match your filters.</p>
              )}

              {displayCount < filteredMovies.length && (
                <div className='load-more-btn flex center'>
                  <button className='btn btn-primary' onClick={handleLoadMore}>
                    Load More
                  </button>
                </div>
              )}
            </>
          ) : (
            <SkeletonGrid count={18} />
          )}
        </div>
      </section>
    </>
  )
}

export default Movies
